import React, { forwardRef } from 'react';

const Radio = forwardRef(
  ({ label, checked, onChange, value, name, disabled = false, className = '', id, ...props }, ref) => {
    const radioId = id || (label && name ? `r-${name}-${value}` : undefined);
    return (
      <label
        htmlFor={radioId}
        className={`inline-flex items-center gap-2 cursor-pointer select-none ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        } ${className}`}
      >
        <span className="relative inline-flex">
          <input
            ref={ref}
            id={radioId}
            type="radio"
            checked={!!checked}
            onChange={onChange}
            value={value}
            name={name}
            disabled={disabled}
            className="peer sr-only"
            {...props}
          />
          <span
            className="w-5 h-5 rounded-full border-2 border-gray-300 bg-white
              peer-checked:border-primary
              peer-focus-visible:ring-2 peer-focus-visible:ring-primary peer-focus-visible:ring-offset-1
              transition-colors inline-flex items-center justify-center"
          >
            {checked && <span className="w-2.5 h-2.5 rounded-full bg-primary" />}
          </span>
        </span>
        {label && <span className="text-sm text-app-text">{label}</span>}
      </label>
    );
  }
);

Radio.displayName = 'Radio';

export default Radio;
